<template>
  <div :class="`content-wrapper ${isMenuOpen ? 'menu-open' : 'menu-closed'}`">
    <div class="notfound-container">
      <div class="error-card">
        <h1>404</h1>
        <!-- <div class="blur-circle"></div>
        <div class="blur-circle secondary"></div> -->
        <p clas="ops-messages my-3">Oops! The page you are looking for does not exist.</p>
        <router-link :to="'/'" class="home-link">Go back to Home</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style lang="scss" scoped>

.notfound-container {
  text-align: center;
  min-height: 100%;
  align-items: center;
  justify-content: center;
  color: #fff;
  position: relative;
  overflow: hidden;
  height: 80vh;
  display: flex;
}

.error-card {
  position: relative;
  background: rgba(30, 41, 59, 0.7);
  backdrop-filter: blur(10px);
  border-radius: 24px;
  padding: 3rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  z-index: 1;
}

p{
    margin:1rem 0rem;
}

p.ops-messages {
    font-size:clamp(14px, 1vw, 20px);
}

.blur-circle {
  position: absolute;
  width: 150px;
  height: 150px;
  background: rgba(99, 102, 241, 0.4);
  border-radius: 50%;
  filter: blur(40px);
  top: -30px;
  left: -30px;
  z-index: -1;
}

.blur-circle.secondary {
  background: rgba(244, 63, 94, 0.4);
  right: -30px;
  bottom: -30px;
  left: auto;
  top: auto;
}

h1 {
  font-size: 8rem;
  font-weight: bold;
  margin: 0;
  background: linear-gradient(135deg, #6366f1 0%, #f43f5e 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  line-height: 1;
  text-shadow: 0 2px 10px rgba(99, 102, 241, 0.3);
  text-align: center;
}

// p {
//   font-size: 1.5rem;
//   color: #e2e8f0;
//   margin: 1.5rem 0;
// }

.home-link {
  display: inline-block;
  padding: 0.75rem 1.5rem;
  color: white;
  text-decoration: none;
  border-radius: 12px;
  font-weight: 500;
  transition: all 0.3s ease;
  border: none;

  &:hover {
    transform: translateY(-2px);
    text-decoration: underline;
  }
}
</style>
